











































import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { FuzzyDateSelectableDialogMixin } from "./mixins";
import DateTimeSelector from "../../../../system/selectors/DateTimeSelector.vue";
import { ITimeFormatConfiguration } from "../../../../../domain/configuration/IConfiguration";
import { DateFormatter } from "../../../../../domain/system";

interface IPhraseInformation {
  label: string;
  value: string;
  shouldSetLinkedDate: boolean;
}

@Component({
  components: {
    DateTimeSelector,
  },
})
export default class FuzzyTimeSelectDialog extends Mixins(FuzzyDateSelectableDialogMixin) {
  $refs!: {
    dateTimeSelector: DateTimeSelector;
  };

  get customClassName(): string {
    return this.dialogClass
      ? "fuzzy-time-select-dialog " + this.dialogClass
      : "fuzzy-time-select-dialog";
  }

  get formatConfiguration(): ITimeFormatConfiguration {
    const configuration = this.$configuration.behavior.document.entities.time;
    return configuration
      ? Enumerable.from(configuration.formats.concat(configuration.formatsIncludeSecond)).firstOrDefault(c => c.format === this.condition.format)
      : null;
  }

  get phrases(): IPhraseInformation[][] {
    return [
      [
        {
          label: this.indeterminationAsString,
          value: this.indeterminationAsString,
          shouldSetLinkedDate: false,
        },
        {
          label: this.unknownAsString,
          value: this.unknownAsString,
          shouldSetLinkedDate: false,
        },
        {
          label: this.aroundSelectedHourAsString,
          value: this.aroundSelectedHourValueAsString,
          shouldSetLinkedDate: true,
        },
      ],
    ];
  }

  get aroundSelectedHourAsString(): string {
    return this.selectedHours + "時頃";
  }

  get aroundSelectedHourValueAsString(): string {
    return this.formatConfiguration
      ? DateFormatter.format(this.selectedDate, this.formatConfiguration.fuzzyFormat) + "頃"
      : this.aroundSelectedHourAsString;
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean) {
    if (newValue) {
      this.$nextTick(() => {
        if (this.$refs.dateTimeSelector) {
          this.$refs.dateTimeSelector.setFocus();
        }
      });
    }
  }
}
